import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';
import axios from './config';
import {
  ADD_LOAD_FILTER,
  BOOK_LOAD,
  GET_LOADS,
  GET_LOAD_FILTER,
  SET_LOAD_DETAILS,
  UPDATE_LOAD_FILTER,
} from '../../@jumbo/constants/ActionTypes';
import {
  bidLoadApi,
  bookLoadApi,
  bulkUploadApi,
  getEquipmentsApi,
  getFiltersApi,
  getLoadsApi,
  getDocumentsApi,
  provideApprovalApi,
  getDocumentsDetailsApi,
  getInterestsApi,
  moveLoadsToRequestsApi,
  getLanesApi,
  createLanesApi,
  editLaneApi,
  editInterestsApi,
  getLoadsDetailsApi,
  approveOrRejectDocumentsApi,
  getCarriersApi,
  getCarrierDetailsApi,
  getCarriersFromAppOrchidApi,
  getAppOrchidTokenApi,
} from 'redux/apis/loads';

export const GET_LOADS_REQUEST = 'GET_LOADS_REQUEST';
export const getLoads = (filterOptions = []) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      dispatch({ type: GET_LOADS_REQUEST });
      getLoadsApi(filterOptions)
        .then(data => {
          dispatch({ type: GET_LOADS, payload: data.data });
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const GET_FILTERS_SUCCESSFUL = 'GET_FILTERS_SUCCESSFUL';
export const getFilters = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getFiltersApi()
        .then(data => {
          dispatch(fetchSuccess());
          dispatch({ type: GET_FILTERS_SUCCESSFUL, payload: data.data });
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const setCurrentLoad = load => {
  return dispatch => {
    dispatch({ type: SET_LOAD_DETAILS, payload: load });
  };
};

export const getLoadFilter = callbackFun => {
  return dispatch => {
    const filter = JSON.parse(localStorage.getItem('load_filter'));
    dispatch({ type: GET_LOAD_FILTER, payload: filter });
    if (callbackFun) callbackFun(filter);
  };
};

export const addLoadFilter = (filter, callbackFun) => {
  return dispatch => {
    localStorage.setItem('load_filter', JSON.stringify(filter));
    dispatch({ type: ADD_LOAD_FILTER, payload: filter });
    if (callbackFun) callbackFun(filter);
  };
};

export const updateLoadFilter = (filter, callbackFun) => {
  return dispatch => {
    localStorage.setItem('load_filter', JSON.stringify(filter));
    dispatch({ type: UPDATE_LOAD_FILTER, payload: filter });
    if (callbackFun) callbackFun(filter);
  };
};

export const bookLoad = data => {
  return dispatch => {
    dispatch(fetchStart());
    bookLoadApi(data)
      .then(response => {
        dispatch(postSuccess('Load booked successfully.'));
        dispatch({ type: BOOK_LOAD, payload: response.data });
      })
      .catch(error => {
        dispatch(fetchError(error.response && error.response.data.error));
      });
  };
};

export function bidLoad(id, data) {
  return dispatch => {
    dispatch(fetchStart());
    bidLoadApi(id, data)
      .then(response => {
        dispatch(postSuccess('Load bid successfully.'));
        dispatch({ type: BOOK_LOAD, payload: response.data });
      })
      .catch(error => {
        dispatch(fetchError(error.response && error.response.data.error));
      });
  };
}

export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS';
export function getDocuments(data = {}, resetRedux=true) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // dispatch(fetchStart());
      getDocumentsApi(data)
        .then(res => {
          // dispatch(fetchSuccess());
          dispatch({
            type: GET_DOCUMENTS_SUCCESS,
            payload: res,
            resetRedux:resetRedux
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was some issue in the response from server'));
          reject(error);
        });
    });
  };
}

export const GET_DOCUMENTS_DETAILS_SUCCESS = 'GET_DOCUMENTS_DETAILS_SUCCESS';
export function getDocumentsDetails(id = '') {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // dispatch(fetchStart());
      getDocumentsDetailsApi(id)
        .then(res => {
          // dispatch(fetchSuccess());
          dispatch({
            type: GET_DOCUMENTS_DETAILS_SUCCESS,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was some issue in the response from server'));
          reject(error);
        });
    });
  };
}

export function provideApproval(id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      provideApprovalApi(id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError(error.message));
          reject(error);
        });
    });
  };
}

export function bulkUpload(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      bulkUploadApi(data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There is an error while uploading a batch of loads. Please check the data and try again.'));
          reject(error);
        });
    });
  };
}

export const GET_EQUIPMENT_SUCCESSFULL = 'GET_EQUIPMENT_SUCCESSFULL';
export function getEquipments() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getEquipmentsApi()
        .then(res => {
          dispatch({
            type: GET_EQUIPMENT_SUCCESSFULL,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_INTERESTS = 'GET_INTERESTS';
export function getInterests(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart())
      getInterestsApi(data)
        .then(res => {
          dispatch({
            type: GET_INTERESTS,
            payload: res.data,
          });
          dispatch(fetchSuccess())
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError('There was some issue in responding server'));
          reject(err);
        });
    });
  };
}

export function editInterests(id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart())
      editInterestsApi(id, data)
        .then(res => {
          dispatch(postSuccess(`Interest has been ${data.status} successfully.`))
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError('There was some issue in responding server'));
          reject(err);
        });
    });
  };
}

export function moveLoadsToRequests(load_id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      moveLoadsToRequestsApi(load_id, data)
        .then(res => {
          dispatch(postSuccess(`Load moved to ${data.request_type} in Requests section.`))
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError(err?.response?.data?.error ?? `Failed moving to ${data.request_type} in Requests section.`));
          reject(err);
        });
    });
  };
}

export const GET_LANES_SUCCESSFUL = 'GET_LANES_SUCCESSFUL';
export function getLanes(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getLanesApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_LANES_SUCCESSFUL,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was some issue in responding server'));
          reject(error);
        });
    });
  };
}

export function batchUploadLanes(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      createLanesApi(data)
        .then(res => {
          dispatch(postSuccess("Lane Uploaded Successfully"))
          resolve(res || "success");
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export function editLane(id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      editLaneApi(id, data)
        .then(res => {
          dispatch(postSuccess("Lane Updated Successfully"))
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export function deleteLane(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      editLaneApi(id, { is_active: false })
        .then(res => {
          dispatch(postSuccess("Lane Deleted Successfully"))
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_LOADS_DETAILS_SUCCESSFUL = 'GET_LOADS_DETAILS_SUCCESSFUL';
export function getLoadsDetails(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getLoadsDetailsApi(id).then(res => {
        dispatch(fetchSuccess())
        dispatch({
          type: GET_LOADS_DETAILS_SUCCESSFUL,
          payload: res.data
        })
        resolve(res)
      })
      .catch(err => {
        dispatch(fetchError('There was some issue in responding server'))
        reject(err)
      })
    });
  };
}

export const CLEAR_SELECTED_DOCUMENT_DETAILS = 'CLEAR_SELECTED_DOCUMENT_DETAILS';
export function clearSelectedDocumentDetails() {
  return dispatch => {
    dispatch({
      type: CLEAR_SELECTED_DOCUMENT_DETAILS
    })
  };
}

export function approveOrRejectDocuments(payload, dispatchId){
  return dispatch => {
    return new Promise((resolve, reject) => {
      //dispatch(fetchStart());
      approveOrRejectDocumentsApi(payload, dispatchId).then(res => {
        // dispatch(postSuccess("Document statuses were updated successfully"));
        resolve(res)
      })
      .catch(err => {
        //dispatch(fetchError("Failed to update the status of documents, please try again"));
        reject(err)
      })
    });
  };
}

export const GET_CARRIER_SUCCESSFUL = 'GET_CARRIER_SUCCESSFUL';
export function getCarriers(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getCarriersApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_CARRIER_SUCCESSFUL,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was some issue in responding server'));
          reject(error);
        });
    });
  };
}

export const UPDATE_SELECTED_DOCUMENT_DETAILS = 'UPDATE_SELECTED_DOCUMENT_DETAILS';
export function updateSelectedDocumentDetails(documentDetails) {
  return dispatch => {
    dispatch({
      type: UPDATE_SELECTED_DOCUMENT_DETAILS,
      payload: documentDetails
    })
  };
}

export const GET_CARRIER_DETAILS_SUCCESSFUL = 'GET_CARRIER_DETAILS_SUCCESSFUL';
export function getCarrierDetails(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getCarrierDetailsApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_CARRIER_DETAILS_SUCCESSFUL,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was some issue in responding server'));
          reject(error);
        });
    });
  };
}

// export const GET_CARRIER_FROM_APP_ORCHID_SUCCESSFUL = 'GET_CARRIER_FROM_APP_ORCHID_SUCCESSFUL';
export function getAppOrchidToken(){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart())
      getAppOrchidTokenApi()
      .then(res => {
        let data = {}
        data["access_token"] = res.access_token
        data["valid_till"] = Math.round((new Date()).getTime() / 1000) + Number(res.expires_in)
        localStorage.setItem("appOrchid", JSON.stringify(data))
        resolve(res);
      })
      .catch(error => {
        dispatch(fetchError('There was some issue in responding server'));
        reject(error);
      });
    })
  }
}

export function getCarriersFromAppOrchid(data, token) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getCarriersFromAppOrchidApi(data, token)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_CARRIER_SUCCESSFUL,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was some issue in responding server'));
          reject(error);
        });
    });
  };
}